import { render } from "./ViewProvider.vue?vue&type=template&id=17fb93ef&scoped=true&ts=true"
import script from "./ViewProvider.vue?vue&type=script&lang=ts"
export * from "./ViewProvider.vue?vue&type=script&lang=ts"

import "./ViewProvider.vue?vue&type=style&index=0&id=17fb93ef&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fb93ef"]])

export default __exports__